module.exports = Em.Service.extend
  session: Em.inject.service()
  env: Em.inject.service('environment')

  getSuggestions: (address) ->
    baseRoot = @get('env.apiRoot')
    key = @get('session.apiKey')
    
    items = []
    url = "#{baseRoot}/api/addresses?query=#{address}"

    ajaxProps = 
        url: url
        dataType: 'json'
        headers: 'Authorization': "Token token=\"#{key}\""

    Ember.$.ajax(ajaxProps)